// extracted by mini-css-extract-plugin
export default {"ruleDone":"RuleText_ruleDone__m4u9l","ruleTodo":"RuleText_ruleTodo__yEjz7"};